<ul
  [items]="model"
  [parentActive]="true"
  [root]="true"
  [visible]="true"
  app-submenu
  class="layout-menu"
  style="margin-bottom: 1rem"></ul>
